import React, { useEffect, useRef, useState } from 'react';
import { Accordion, Button, Container, Icon, Table } from 'semantic-ui-react';
import { Helmet } from '@plone/volto/helpers/Helmet/Helmet';
import { flattenToAppURL } from '@plone/volto/helpers/Url/Url';
import { Link } from 'react-router-dom';
import CVOverlay from 'volto-facultycv/components/Views/CVOverlay';
import EnhancedCVOverlay from 'volto-facultycv/components/Views/EnhancedCVOverlay';
import { useDispatch, useSelector } from 'react-redux';
import jwtDecode from 'jwt-decode';
import 'volto-facultycv/directory.css';
import get_faculty_data from 'volto-facultycv/actions/get_faculty_data/get_faculty_data';

const ProfileDefault = ({ content }) => {
  const dispatch = useDispatch();
  // accordionazed
  const [activeIndex, setActiveIndex] = useState(0);
  const [results, setResults] = useState([]);

  useEffect(() => {
    try {
      const fetchResults = async () => {
        const response = await dispatch(get_faculty_data(flattenToAppURL(`${content?.['@id']}`)));
        setResults(response?.items[0]);
        return results;
      };
      fetchResults();
    } catch (error) {
      console.error('error: ', error);
    }
  }, []);

  const handleClick = (e, titleProps) => {
    e.preventDefault();
    const newIndex = activeIndex === titleProps.index ? -1 : titleProps.index;
    // Update state
    setActiveIndex(newIndex);
  };

  const [isActive, setIsActive] = useState(false);
  const contentRef = useRef(null);
  // end accordionazed

  // const content = useSelector((store) => store?.content?.data);
  const userid = useSelector((state) => (state.userSession.token ? jwtDecode(state.userSession.token).sub : ''));

  return (
    <Container className="view-wrapper">
      <div>
        <Helmet title={`${content?.title} - York College / CUNY`} />

        <div className="block hero">
          <div className="block-inner-wrapper">
            {content?.image && <img src={content?.image?.scales.mini.download} alt={content?.title} className="hero-image portraitPhoto" loading="lazy" />}

            <div className="hero-body">
              <div className="hero-text">
                <h1>{content?.title}</h1>
                <p className="documentDescription">
                  <strong>
                    {content?.teachingTitle}
                    {content?.orgStatus === 'Chair' && <> and {content?.orgStatus}</>}
                    {content?.orgStatus === 'Acting Chair' && <> and {content?.orgStatus}</>}
                  </strong>
                  <br />
                  {content?.otherTitle && content?.otherTitle}

                  <br />
                  {content?.dept && (
                    <Link
                      to={flattenToAppURL(
                        `/${content?.dept
                          .replace(/[,.]/g, '') // Removes all commas and periods
                          .replace(/\band\b/g, '') // Removes the word 'and'
                          .replace(/\s+/g, '-') // Replaces all spaces with hyphens
                          .toLowerCase()}`,
                      )}
                    >
                      <strong>{content?.dept}</strong>
                    </Link>
                  )}
                </p>

                <p>
                  Phone: {content?.officePhone && content?.officePhone}
                  <br />
                  Office Location: {content?.officeLocation && content?.officeLocation}
                  <br />
                  Email: {content?.email && (
                    <a href={`mailto: ${content?.email}`}>
                      <strong>{content?.email}</strong>
                    </a>
                  )}
                </p>
              </div>
              {content?.website && (
                <div className="link-more">
                  <a href={`${content?.website}`} target="_blank" rel="noopener noreferrer" className="external">
                    Personal Website
                  </a>
                </div>
              )}
            </div>
          </div>
        </div>
        <p
          dangerouslySetInnerHTML={{
            __html: content?.briefBio ? content?.briefBio : null,
          }}
        />
        <Container textAlign="center">
          <div className="btn-group btn-group-xs">
            <Button type="button" className="btn btn-default" disabled>
              Overview
            </Button>
            {!content?.hidecv && <CVOverlay />}
            {content?.can_modify_portal_content === 'True' && <EnhancedCVOverlay />}
            {/*{userid ? <PBActionTypeViewOverlay /> : null}*/}
            {/*{content && content?.items && content?.items[0]?.['@type'] && (<PBDocsRepoComponent />)}*/}
          </div>
        </Container>

        {content?.officeHours && (
          <>
            <h2>Office Hours</h2>
            <Table className="table">
              <Table.Row>
                <Table.HeaderCell>Day</Table.HeaderCell>
                <Table.HeaderCell>Time</Table.HeaderCell>
              </Table.Row>
              {content?.officeHours &&
                content?.officeHours.map((item) => (
                  <Table.Row>
                    <Table.Cell>{item.day}</Table.Cell>
                    <Table.Cell>{item.time}</Table.Cell>
                  </Table.Row>
                ))}
            </Table>
          </>
        )}
        {content?.education && (
          <>
            <h2>Education</h2>
            <Table className="table table-striped">
              <Table.Row>
                <Table.HeaderCell>Degree</Table.HeaderCell>
                <Table.HeaderCell>Institution</Table.HeaderCell>
                <Table.HeaderCell>Field</Table.HeaderCell>
                <Table.HeaderCell>Dates</Table.HeaderCell>
              </Table.Row>
              {content?.education &&
                content?.education.map((item) => (
                  <Table.Row>
                    <Table.Cell>{item.degree}&nbsp;</Table.Cell>
                    <Table.Cell>{item.institution}&nbsp;</Table.Cell>
                    <Table.Cell>{item.area}&nbsp;</Table.Cell>
                    <Table.Cell>{item.year}&nbsp;</Table.Cell>
                  </Table.Row>
                ))}
            </Table>
          </>
        )}

        {content?.areaExpertise ? (
          <>
            <h2>Areas of Expertise</h2>
            <ul>
              {content?.areaExpertise.map((item) => (
                <li>{item}</li>
              ))}
            </ul>
          </>
        ) : null}

        <h2>Publications in Field Of Expertise</h2>
        <Accordion styled className="accordion-block">
          {results?.books && results?.books.some((book) => book.status === 'ife') && (
            <>
              <Accordion.Title active={activeIndex === 0} index={0} onClick={handleClick}>
                <Icon name="dropdown" />
                <h3>Books</h3>
              </Accordion.Title>
              <Accordion.Content active={activeIndex === 0}>
                {results?.books.map(
                  (book) =>
                    book.status === 'ife' && (
                      <ul style={{ listStyleType: 'none' }} key={book?.['@id']}>
                        <li>
                          {book?.authors}. <u>
                            <a href={book?.url}>{book?.title}</a>
                          </u>. {book?.place}: {book?.publisher}, {book?.date}. {book?.pages}.
                        </li>
                      </ul>
                    ),
                )}
              </Accordion.Content>
            </>
          )}

          {results?.articles && results?.articles.some((article) => article.status === 'ife') && (
            <>
              <Accordion.Title active={activeIndex === 1} index={1} onClick={handleClick}>
                <Icon name="dropdown" />
                <h3>Articles</h3>
              </Accordion.Title>
              <Accordion.Content active={activeIndex === 1}>
                {results?.articles &&
                  results?.articles.map(
                    (article) =>
                      article.status === 'ife' && (
                        <ul style={{ listStyleType: 'none' }} key={article?.['@id']}>
                          <li>
                            {article?.authors}. &quot;<a href={article?.url}>{article?.title}</a>.&quot; <i>{article?.journalTitle}</i>. {article?.volume} {article?.date}: {article?.pages}.
                          </li>
                        </ul>
                      ),
                  )}
              </Accordion.Content>
            </>
          )}

          {results?.chapters && results?.chapters.some((chapter) => chapter.status === 'ife') && (
            <>
              <Accordion.Title active={activeIndex === 2} index={2} onClick={handleClick}>
                <Icon name="dropdown" />
                <h3>Chapters</h3>
              </Accordion.Title>
              <Accordion.Content active={activeIndex === 2}>
                {results?.chapters &&
                  results?.chapters.map(
                    (chapter) =>
                      chapter.status === 'ife' && (
                        <ul style={{ listStyleType: 'none' }} key={chapter?.['@id']}>
                          <li key={(chapter.status = 'ife')}>
                            {chapter?.authors}. &quot;<a href={chapter?.url}>{chapter?.title}</a>.&quot; <i>{chapter?.journalTitle}</i>. {chapter?.volume} {chapter?.date}: {chapter?.pages}.
                          </li>
                        </ul>
                      ),
                  )}
              </Accordion.Content>
            </>
          )}

          {results?.refereedProceedings && results?.refereedProceedings.some((item) => item.status === 'ife') && (
            <>
              <Accordion.Title active={activeIndex === 3} index={3} onClick={handleClick}>
                <Icon name="dropdown" />
                <h3>Refereed Proceedings</h3>
              </Accordion.Title>
              <Accordion.Content active={activeIndex === 3}>
                {results?.refereedProceedings &&
                  results?.refereedProceedings.map(
                    (item) =>
                      item.status === 'ife' && (
                        <ul style={{ listStyleType: 'none' }} key={item['@id']}>
                          <li key={(item.status = 'ife')}>
                            {item?.authors}. &quot;<a href={item?.url}>{item?.title}</a>.&quot; <i>{item?.journalTitle}</i>. {item?.volume} {item?.date}: {item?.pages}.
                          </li>
                        </ul>
                      ),
                  )}
              </Accordion.Content>
            </>
          )}

          {results?.nonRefereedProceedings && results?.nonRefereedProceedings.some((item) => item.status === 'ife') && (
            <>
              <Accordion.Title active={activeIndex === 4} index={4} onClick={handleClick}>
                <Icon name="dropdown" />
                <h3>Non Refereed Proceedings</h3>
              </Accordion.Title>
              <Accordion.Content active={activeIndex === 4}>
                {results?.nonRefereedProceedings &&
                  results?.nonRefereedProceedings.map(
                    (item) =>
                      item.status === 'ife' && (
                        <ul style={{ listStyleType: 'none' }} key={item['@id']}>
                          <li key={(item.status = 'ife')}>
                            {item.authors}. &quot;<a href={item.url}>{item.title}</a>.&quot; <i>{item.journalTitle}</i>. {item.volume} {item.date}: {item.pages}.
                          </li>
                        </ul>
                      ),
                  )}
              </Accordion.Content>
            </>
          )}

          {results?.monographs && results?.monographs.some((item) => item.status === 'ife') && (
            <>
              <Accordion.Title active={activeIndex === 5} index={5} onClick={handleClick}>
                <Icon name="dropdown" />
                <h3>Monographs</h3>
              </Accordion.Title>
              <Accordion.Content active={activeIndex === 5}>
                {results?.monographs &&
                  results?.monographs.map(
                    (item) =>
                      item.status === 'ife' && (
                        <ul style={{ listStyleType: 'none' }} key={item['@id']}>
                          <li key={(item.status = 'ife')}>
                            {item.authors}. &quot;<a href={item.url}>{item.title}</a>.&quot; <i>{item.journalTitle}</i>. {item.volume} {item.date}: {item.pages}.
                          </li>
                        </ul>
                      ),
                  )}
              </Accordion.Content>
            </>
          )}

          {results?.reviews && results?.reviews.some((item) => item.status === 'ife') && (
            <>
              <Accordion.Title active={activeIndex === 6} index={6} onClick={handleClick}>
                <Icon name="dropdown" />
                <h3>Reviews</h3>
              </Accordion.Title>
              <Accordion.Content active={activeIndex === 6}>
                {results?.reviews &&
                  results?.reviews.map(
                    (item) =>
                      item.status === 'ife' && (
                        <ul style={{ listStyleType: 'none' }} key={item['@id']}>
                          <li key={(item.status = 'ife')}>
                            &quot;<a href={item.url}>{item.publication}</a>
                            &quot; <i>{item?.title}</i>, {item?.publisher}. {item.date}:{item.pages} {item?.place}.
                          </li>
                        </ul>
                      ),
                  )}
              </Accordion.Content>
            </>
          )}
        </Accordion>
        <h2>Other</h2>
        <Accordion styled className="accordion-block">
          {results?.presented && results?.presented.some((item) => item.title) && (
            <>
              <Accordion.Title active={activeIndex === 7} index={7} onClick={handleClick}>
                <Icon name="dropdown" />
                <h3>Presented Papers, Lectures, and Exhibitions and Performances</h3>
              </Accordion.Title>
              <Accordion.Content active={activeIndex === 7}>
                {results?.presented &&
                  results?.presented.map((item) => (
                    <ul style={{ listStyleType: 'none' }} key={item['@id']}>
                      <li>
                        &quot;<a href={item.url}>{item.title}</a>
                        &quot; {item.date}: {item.audience}.
                      </li>
                    </ul>
                  ))}
              </Accordion.Content>
            </>
          )}

          {results?.patents && results?.patents.some((item) => item.title) && (
            <>
              <Accordion.Title active={activeIndex === 8} index={8} onClick={handleClick}>
                <Icon name="dropdown" />
                <h3>Patents</h3>
              </Accordion.Title>
              <Accordion.Content active={activeIndex === 8}>
                {results?.patents &&
                  results?.patents.map((item) => (
                    <ul style={{ listStyleType: 'none' }} key={item['@id']}>
                      <li>
                        {item.inventor}. {item.date}. <a href={item.url}>{item.title}</a>. {item.country} Patent {item.patent}, {item.filed}, and {item.issue}.
                      </li>
                    </ul>
                  ))}
              </Accordion.Content>
            </>
          )}

          {results?.professional && results?.professional.some((item) => item.description) && (
            <>
              <Accordion.Title active={activeIndex === 9} index={9} onClick={handleClick}>
                <Icon name="dropdown" />
                <h3>Professional Honors, Prizes, Fellowships</h3>
              </Accordion.Title>
              <Accordion.Content active={activeIndex === 9}>
                {results?.professional &&
                  results?.professional.map((item) => (
                    <ul style={{ listStyleType: 'none' }} key={item['@id']}>
                      <li>
                        {item.description}: {item.dates}.
                      </li>
                    </ul>
                  ))}
              </Accordion.Content>
            </>
          )}

          {results?.grants && results?.grants.some((item) => item.title) && (
            <>
              <Accordion.Title active={activeIndex === 10} index={10} onClick={handleClick}>
                <Icon name="dropdown" />
                <h3>Grants-In-Aid</h3>
              </Accordion.Title>
              <Accordion.Content active={activeIndex === 10}>
                {results?.grants &&
                  results?.grants.map((item) => (
                    <ul style={{ listStyleType: 'none' }} key={item['@id']}>
                      <li>
                        {item.agency}, {item.title}. {item.dates}: {item.amount}.
                      </li>
                    </ul>
                  ))}
              </Accordion.Content>
            </>
          )}

          {results?.officeHeld && results?.officeHeld.some((item) => item.description) && (
            <>
              <Accordion.Title active={activeIndex === 11} index={11} onClick={handleClick}>
                <Icon name="dropdown" />
                <h3>Offices Held In Professional Societies</h3>
              </Accordion.Title>
              <Accordion.Content active={activeIndex === 11}>
                {results?.officeHeld &&
                  results?.officeHeld.map((item) => (
                    <ul style={{ listStyleType: 'none' }} key={item['@id']}>
                      <li>
                        {item.description}: {item.dates}.
                      </li>
                    </ul>
                  ))}
              </Accordion.Content>
            </>
          )}

          {results?.activities && results?.activities.some((item) => item.description) && (
            <>
              <Accordion.Title active={activeIndex === 12} index={12} onClick={handleClick}>
                <Icon name="dropdown" />
                <h3>Other Professional Activities and Public Service</h3>
              </Accordion.Title>
              <Accordion.Content active={activeIndex === 12}>
                {results?.activities &&
                  results?.activities.map((item) => (
                    <ul style={{ listStyleType: 'none' }} key={item['@id']}>
                      <li>
                        {item.description}: {item.dates}.
                      </li>
                    </ul>
                  ))}
              </Accordion.Content>
            </>
          )}
        </Accordion>
      </div>
    </Container>
  );
};

export default ProfileDefault;
